import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { ReceivingTransactionIndexedDbService } from '../domain/receiving-transaction/repository/receiving-transaction-indexed-db';
import { DispatchTransactionIndexedDbService } from '../domain/dispatch-transaction/repository/dispatch-transaction-indexed-db.service';
import { DispatchPicklistApprovalIndexedDbService } from '../domain/dispatch-picklist-approval/repository/dispatch-picklist-approval-indexed-db.service';
import { DisposalPicklistApprovalIndexedDbService } from '../domain/disposal-picklist-approval/repository/disposal-picklist-approval-indexed-db.service';
import { OutgoingRequestIndexedDbService } from '../domain/outgoing-request/repository/outgoing-request-indexed-db';

const DB_NAME: string = 'PezaIndexedDB';
const DB_VERSION: number = 7;

export const DB_CONFIG: DBConfig = {
  name: DB_NAME,
  version: DB_VERSION,
  objectStoresMeta: [
    {
      store: ReceivingTransactionIndexedDbService.STORE_NAME,
      storeConfig: { keyPath: 'dr_number', autoIncrement: false },
      storeSchema: [
        {
          name: 'draft_list',
          keypath: 'draft_list',
          options: { unique: false },
        },
        {
          name: 'image_list',
          keypath: 'image_list',
          options: { unique: false },
        },
        { name: 'header', keypath: 'header', options: { unique: false } },
      ],
    },
    {
      store: DispatchTransactionIndexedDbService.STORE_NAME,
      storeConfig: { keyPath: 'dispatch_id', autoIncrement: false },
      storeSchema: [
        { name: 'detail', keypath: 'detail', options: { unique: false } },
        {
          name: 'image_list',
          keypath: 'image_list',
          options: { unique: false },
        },
      ],
    },
    {
      store: DispatchPicklistApprovalIndexedDbService.STORE_NAME,
      storeConfig: { keyPath: 'outgoing_request_id', autoIncrement: false },
      storeSchema: [
        { name: 'detail', keypath: 'detail', options: { unique: false } },
      ],
    },
    {
      store: DisposalPicklistApprovalIndexedDbService.STORE_NAME,
      storeConfig: { keyPath: 'disposal_picklist_id', autoIncrement: false },
      storeSchema: [
        { name: 'details', keypath: 'details', options: { unique: false } },
      ],
    },
    {
      store: OutgoingRequestIndexedDbService.STORE_NAME,
      storeConfig: { keyPath: 'outgoing_request_id', autoIncrement: false },
      storeSchema: [
        { name: 'detail', keypath: 'detail', options: { unique: false } },
        { name: 'header', keypath: 'header', options: { unique: false } },
      ],
    },
  ],
  migrationFactory,
};

export function migrationFactory() {
  return {
    7: (db: IDBDatabase, transaction: IDBTransaction) => {
      if (
        !db.objectStoreNames.contains(
          DisposalPicklistApprovalIndexedDbService.STORE_NAME
        )
      ) {
        const disposal_store = db.createObjectStore(
          DisposalPicklistApprovalIndexedDbService.STORE_NAME,
          { keyPath: 'disposal_picklist_id', autoIncrement: false }
        );
        disposal_store.createIndex('details', 'details', { unique: false });
      }
    },
    6: (db: IDBDatabase, transaction: IDBTransaction) => {
      if (
        !db.objectStoreNames.contains(
          OutgoingRequestIndexedDbService.STORE_NAME
        )
      ) {
        const outgoing_request_store = db.createObjectStore(
          OutgoingRequestIndexedDbService.STORE_NAME,
          { keyPath: 'outgoing_request_id', autoIncrement: false }
        );
        outgoing_request_store.createIndex('detail', 'detail', {
          unique: false,
        });
        outgoing_request_store.createIndex('header', 'header', {
          unique: false,
        });
      }
    },
    5: (db: IDBDatabase, transaction: IDBTransaction) => {
      // Recreate dispatch store with new keyPath
      if (
        db.objectStoreNames.contains(
          DispatchTransactionIndexedDbService.STORE_NAME
        )
      ) {
        db.deleteObjectStore(DispatchTransactionIndexedDbService.STORE_NAME);
      }
      const dispatch_store = db.createObjectStore(
        DispatchTransactionIndexedDbService.STORE_NAME,
        { keyPath: 'dispatch_id' }
      );
      dispatch_store.createIndex('detail', 'detail', { unique: false });
      dispatch_store.createIndex('image_list', 'image_list', { unique: false });
    },
    4: (db: IDBDatabase, transaction: IDBTransaction) => {
      const receiving_store = transaction.objectStore(
        ReceivingTransactionIndexedDbService.STORE_NAME
      );
      receiving_store.createIndex('header', 'header', { unique: false });
    },
    3: (db: IDBDatabase, transaction: IDBTransaction) => {
      const dpa_store = transaction.objectStore(
        DispatchPicklistApprovalIndexedDbService.STORE_NAME
      );
      dpa_store.createIndex('detail', 'detail', { unique: false });
    },
    2: (db: IDBDatabase, transaction: IDBTransaction) => {
      const receiving_store = transaction.objectStore(
        ReceivingTransactionIndexedDbService.STORE_NAME
      );
      receiving_store.createIndex('image_list', 'image_list', {
        unique: false,
      });

      const dispatch_store = transaction.objectStore(
        DispatchTransactionIndexedDbService.STORE_NAME
      );
      dispatch_store.createIndex('detail', 'detail', { unique: false });
      dispatch_store.createIndex('image_list', 'image_list', { unique: false });
    },
    1: (db: IDBDatabase, transaction: IDBTransaction) => {
      const receiving_store = transaction.objectStore(
        ReceivingTransactionIndexedDbService.STORE_NAME
      );
      receiving_store.createIndex('draft_list', 'draft_list', {
        unique: false,
      });
    },
  };
}
